import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Input, FormGroup, Button } from '../styles/components';
import { SignUpLink } from './SignUp';
import { auth, googleAuth } from '../firebase';
import * as routes from '../constants/routes';
import { PasswordForgetLink } from './PasswordForget';
const SignInPage = ({ history, layoutItem: LayoutItem }) => (
  <LayoutItem>
    <h2>Sign In</h2>
    <SignInForm history={history} />
    <PasswordForgetLink />
    <SignUpLink />
  </LayoutItem>
);
const INITIAL_STATE = { email: '', password: '', error: null };
class SignInForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
    this.loginWithGoogle = this.loginWithGoogle.bind(this);
  }
  loginWithGoogle() {
    auth
      .signInWithPopup(googleAuth)
      .then(() => {
        this.props.history.push(routes.HOME);
      })
      .catch(error => console.log(error));
  }
  onSubmit(event) {
    event.preventDefault();
    const { email, password } = this.state;
    const { history } = this.props;
    auth
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.HOME);
      })
      .catch(error => this.setState({ error }));
  }
  render() {
    const { email, password, error } = this.state;
    const isValid = password.length && email.length;
    return (
      <Form onSubmit={this.onSubmit.bind(this)}>
        <FormGroup>
          <Button type="button" onClick={this.loginWithGoogle}>
            log in with google
          </Button>
        </FormGroup>
        <FormGroup>
          <Input
            type="email"
            value={email}
            onChange={({ target }) => this.setState({ email: target.value })}
            placeholder="email"
          />
        </FormGroup>
        <FormGroup>
          <Input
            value={password}
            type="password"
            onChange={({ target }) => this.setState({ password: target.value })}
            placeholder="password"
          />
        </FormGroup>
        <FormGroup>
          <Button>log in</Button>
        </FormGroup>
        {error && <strong>{error.message}</strong>}
      </Form>
    );
  }
}

export default withRouter(SignInPage);

export { SignInForm };
